/**
 * Created by zulqernain on 26/03/19.
 */
import AuthToken from './Token'
import { isEmptyObject } from './Utility'
// import Alert from 'react-s-alert';
// import * as Sentry from '@sentry/browser';
// const request = require('superagent')

const Auth = {

    isAuthenticated: function () {
        var isAuthenticated = false

        if (typeof window !== 'undefined') {

            var user = JSON.parse(window.localStorage.getItem("b2b2cUser")) || {}
            // console.log(user.data)
            // alert("hgfhfh")
            if(isEmptyObject(user)) return false
            let {data:{auth_tokens:{access_token=''}}} = user
            if (user && access_token) {
                var isAuthenticated = true
                return isAuthenticated
            }

        }
        return isAuthenticated

    },

    getTokenFromAuth: function() {
        let token = ''
        if(typeof window !== 'undefined') {
            let user = JSON.parse(window.localStorage.getItem("b2b2cUser")) || {}
            if(isEmptyObject(user)) return null
            let {data:{auth_tokens:{access_token=''}}} = user || {};
            token = access_token || ""
            return token;
        }
    },
    
    handle401: function (err) {

        var self = this
        var field = AuthToken.REFRESH_TOKEN
        var formData = {
            refresh_token: AuthToken.getToken(AuthToken.REFRESH_TOKEN),
        }

//         request.post(process.env.RAZZLE_API_ACCESS_TOKEN_RENEW)
//             .set('Content-Type', 'application/json')
//             .set('Accept', 'application/json')
//             .set({'source': 'website'})
//             .send(formData)
//             .end((error, response) => {
//                 if (error) {
//                     /*Note: Refresh token got expired, go to login page again*/
//
//                     //console.log(error)
//                     //console.log(error.status)
//                     AuthToken.deleteToken(AuthToken.ACCESS_TOKEN)
//                     AuthToken.deleteToken(AuthToken.REFRESH_TOKEN)
//                     // Alert.warning('<div class="center-align">You are logged out! <br /> <a href="/en/login">Please click here to login again.</a></div>', {
//                     //     html: true
//                     // });
//                     // Sentry.captureException(error);
//
//                 } else {
//                     /*Note: Access token got renewed, reload the page again*/
//
// //                console.log(response)
// //                console.log(response.body)
// //                console.log(response.body.data.access_token)
// //                console.log(AuthToken.ACCESS_TOKEN)
// //                console.log(response.body.data[AuthToken.ACCESS_TOKEN])
//                     if (response.body.status == "success") {
//                         var at = response.body.data[AuthToken.ACCESS_TOKEN]
//                         AuthToken.setToken(at, AuthToken.ACCESS_TOKEN)
//                         // Alert.warning('<div class="center-align">Session expired! <br /> <a href="">Please click here to restart new session.</a></div>', {
//                         //     html: true
//                         // });
//
//                     }
//                 }
//                 //console.log(window.location.pathname.search("\/otp"))
//                 //console.log(window.location.pathname.search("\/otp")!==0)
//                 //if (err.status === 401) {
//                 //    Auth.handle401(err)
//                 //}
//             });
    }
}

// Auth.isAuthenticated = true
export default Auth
